<template>
    <div>

        <table class="table table-borderless">

            <thead> <tr> <th>Name</th> <th>Description</th> <th>Actions</th> </tr> </thead>

            <tbody>
                <tr v-for="(item, key) in dataItems" :key="key">

                    <td>
                        <div class="form-group">
                            <input class="form-control border border-dark" placeholder="Name" type="text" v-model="item.name" />
                        </div>
                    </td>

                    <td>
                        <div class="form-group">
                            <textarea
                                class="form-control border border-dark"
                                placeholder="Description"
                                type="text"
                                v-model.trim="item.description" >
                            </textarea>
                        </div>
                    </td>

                    <td>
                        <update-button :user-permissions="userPermissions" @click="onUpdate(item)">Save</update-button>
                        <delete-button :user-permissions="userPermissions" @click="onDelete(item)">Delete</delete-button>
                    </td>

                </tr>
            </tbody>

        </table>

        <add-button :user-permissions="userPermissions" @click="onAdd({})">New measurement category</add-button>
        <status-feedback :successFeedback="successFeedback" :failFeedback="failFeedback" :errors="errors"></status-feedback>

    </div>
</template>

<script>
import AjaxList from '../../mixins/AjaxListMixin';
import PermissionButtons from '../../mixins/PermissionButtonsMixin';

export default {
    mixins: [AjaxList, PermissionButtons],

    props: {

        items: {
            type: Array,
            default: () => [],
        },

        dataSetId: {
            type: Number,
            required: true,
        }

    },

    data() {
        return {
            dataItems: this.items,
            url: `${APP_URL}/data-collection/data-set-type/${this.dataSetId}/measurement-category`,
        };
    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/measurements-module/data-set-type/DataSetTypeMeasurementCategories.vue